export default __webpack_public_path__ + "static/media/fogo_fh6001r.998d99ff.jpg";